'use strict';

exports.__esModule = true;
exports.getRoleBasedAccess = exports.getUserRole = exports.USER_PRIVILEGES = exports.USER_ROLES = undefined;

var _webUtils = require('@vezeeta/web-utils');

var USER_ROLES = exports.USER_ROLES = {
  OWNER: 'Owner',
  DOCTOR: 'Doctor',
  ASSISTANT: 'Assistant',
  SINGLE_DR_APP: 'SINGLE_DR_APP',
  NURSE: 'Nurse',
  ACCOUNTANT: 'Accountant'
};

var USER_PRIVILEGES = exports.USER_PRIVILEGES = {
  AUTHORIZED: 'AUTHORIZED',
  NOT_AUTHORIZED: 'NOT_AUTHORIZED',
  PERSONALIZED: 'PERSONALIZED'
};

var getInitComponentsPrivilege = function getInitComponentsPrivilege(components) {
  var componentsPrivileges = {};
  components.forEach(function (component) {
    componentsPrivileges[component] = {
      canView: USER_PRIVILEGES.AUTHORIZED
    };
  });
  return componentsPrivileges;
};

var getUserRole = exports.getUserRole = function getUserRole() {
  if (_webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN)) {
    var userToken = (0, _webUtils.decodeJwtToken)(_webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN)).payLoad;
    var userRoles = userToken.role;
    if (userRoles && userRoles.length) {
      if (userRoles.includes('Owner') && !userRoles.includes('Doctor')) return USER_ROLES.OWNER;
      if (!userRoles.includes('Owner') && userRoles.includes('Doctor')) return USER_ROLES.DOCTOR;
      if (userRoles.includes('Assistant')) return USER_ROLES.ASSISTANT;
      if (userRoles.includes('Owner') && userRoles.includes('Doctor')) return USER_ROLES.SINGLE_DR_APP;
      if (userRoles.some(function (role) {
        return role === 'Nurse';
      })) return USER_ROLES.NURSE;
      if (userRoles.some(function (role) {
        return role === 'Finance';
      })) return USER_ROLES.ACCOUNTANT;
    }
  }
  return '';
};

var getRoleBasedAccess = exports.getRoleBasedAccess = function getRoleBasedAccess() {
  var initComponentsPrivilege = getInitComponentsPrivilege([
  // Ads
  'ads',
  // Entity
  'entityManagement',
  // Finance
  'finance',
  // Patients
  'patients', 'addPrescription',
  // Schedule
  'appointments', 'confirmations', 'vacations', 'workingHours', 'managedBranches',
  // Services
  'services']);

  var userRole = getUserRole();

  if (userRole === USER_ROLES.OWNER) {
    initComponentsPrivilege.addPrescription.canView = USER_PRIVILEGES.AUTHORIZED;
    initComponentsPrivilege.addPrescription.canEdit = USER_PRIVILEGES.AUTHORIZED;

    initComponentsPrivilege.services.canView = USER_PRIVILEGES.AUTHORIZED;
    initComponentsPrivilege.services.canEdit = USER_PRIVILEGES.AUTHORIZED;

    return initComponentsPrivilege;
  }
  if (userRole === USER_ROLES.DOCTOR) {
    initComponentsPrivilege.ads.canView = USER_PRIVILEGES.NOT_AUTHORIZED;
    initComponentsPrivilege.ads.canEdit = USER_PRIVILEGES.NOT_AUTHORIZED;

    initComponentsPrivilege.entityManagement.canView = USER_PRIVILEGES.NOT_AUTHORIZED;
    initComponentsPrivilege.entityManagement.canEdit = USER_PRIVILEGES.NOT_AUTHORIZED;

    initComponentsPrivilege.finance.canView = USER_PRIVILEGES.PERSONALIZED;

    initComponentsPrivilege.addPrescription.canView = USER_PRIVILEGES.AUTHORIZED;
    initComponentsPrivilege.addPrescription.canEdit = USER_PRIVILEGES.AUTHORIZED;

    initComponentsPrivilege.appointments.canEdit = USER_PRIVILEGES.PERSONALIZED;
    initComponentsPrivilege.appointments.canView = USER_PRIVILEGES.PERSONALIZED;

    initComponentsPrivilege.confirmations.canEdit = USER_PRIVILEGES.PERSONALIZED;
    initComponentsPrivilege.confirmations.canView = USER_PRIVILEGES.PERSONALIZED;

    initComponentsPrivilege.vacations.canEdit = USER_PRIVILEGES.PERSONALIZED;
    initComponentsPrivilege.vacations.canView = USER_PRIVILEGES.PERSONALIZED;

    initComponentsPrivilege.workingHours.canEdit = USER_PRIVILEGES.PERSONALIZED;
    initComponentsPrivilege.workingHours.canView = USER_PRIVILEGES.PERSONALIZED;

    initComponentsPrivilege.managedBranches.canEdit = USER_PRIVILEGES.NOT_AUTHORIZED;
    initComponentsPrivilege.managedBranches.canView = USER_PRIVILEGES.NOT_AUTHORIZED;

    initComponentsPrivilege.services.canView = USER_PRIVILEGES.AUTHORIZED;
    initComponentsPrivilege.services.canEdit = USER_PRIVILEGES.AUTHORIZED;

    return initComponentsPrivilege;
  }
  if (userRole === USER_ROLES.ASSISTANT) {
    initComponentsPrivilege.ads.canView = USER_PRIVILEGES.NOT_AUTHORIZED;
    initComponentsPrivilege.ads.canEdit = USER_PRIVILEGES.NOT_AUTHORIZED;

    initComponentsPrivilege.entityManagement.canView = USER_PRIVILEGES.NOT_AUTHORIZED;
    initComponentsPrivilege.entityManagement.canEdit = USER_PRIVILEGES.NOT_AUTHORIZED;

    initComponentsPrivilege.finance.canView = USER_PRIVILEGES.NOT_AUTHORIZED;
    initComponentsPrivilege.finance.canEdit = USER_PRIVILEGES.NOT_AUTHORIZED;

    initComponentsPrivilege.addPrescription.canView = USER_PRIVILEGES.NOT_AUTHORIZED;
    initComponentsPrivilege.addPrescription.canEdit = USER_PRIVILEGES.NOT_AUTHORIZED;

    initComponentsPrivilege.managedBranches.canEdit = USER_PRIVILEGES.NOT_AUTHORIZED;
    initComponentsPrivilege.managedBranches.canView = USER_PRIVILEGES.NOT_AUTHORIZED;

    initComponentsPrivilege.services.canView = USER_PRIVILEGES.AUTHORIZED;
    initComponentsPrivilege.services.canEdit = USER_PRIVILEGES.AUTHORIZED;
    return initComponentsPrivilege;
  }

  if (userRole === USER_ROLES.SINGLE_DR_APP) {
    initComponentsPrivilege.patients.canView = USER_PRIVILEGES.AUTHORIZED;
    initComponentsPrivilege.patients.canEdit = USER_PRIVILEGES.AUTHORIZED;

    initComponentsPrivilege.addPrescription.canView = USER_PRIVILEGES.AUTHORIZED;
    initComponentsPrivilege.addPrescription.canEdit = USER_PRIVILEGES.AUTHORIZED;

    initComponentsPrivilege.services.canView = USER_PRIVILEGES.AUTHORIZED;
    initComponentsPrivilege.services.canEdit = USER_PRIVILEGES.AUTHORIZED;
    return initComponentsPrivilege;
  }

  return initComponentsPrivilege;
};